module.exports = __webpack_public_path__ + "img/CY120006.3f2154be.png";